import type { Definition } from '@exodus/dependency-types';

import type { Storage } from '@/background/adapters/storage';
import type { InstallCalloutVisibleAtom } from '@/background/features/pwa/atoms/install-callout-visible';
import { INSTALL_CALLOUT_STORAGE_KEY } from '@/background/features/pwa/atoms/install-callout-visible';
import type { InstallModalVisibleAtom } from './atoms/install-modal-visible.js';

type Dependencies = {
  installModalVisibleAtom: InstallModalVisibleAtom;
  installCalloutVisibleAtom: InstallCalloutVisibleAtom;
  storage: Storage;
};

const createPwaApi = ({
  installModalVisibleAtom,
  installCalloutVisibleAtom,
  storage,
}: Dependencies) => {
  return {
    pwa: {
      hideInstallModal: async () => {
        await installModalVisibleAtom.set(false);
        // Directly write to storage so that observers are not triggered and this is only shown on the next visit.
        await storage.set(INSTALL_CALLOUT_STORAGE_KEY, true);
      },
      hideInstallCallout: async () => {
        await installCalloutVisibleAtom.set(false);
      },
    },
  };
};

const pwaApiDefinition = {
  id: 'pwaApi',
  type: 'api',
  factory: createPwaApi,
  dependencies: [
    'installModalVisibleAtom',
    'storage',
    'installCalloutVisibleAtom',
  ],
} as const satisfies Definition;

export default pwaApiDefinition;
